import { render, staticRenderFns } from "./ProtospellingAutocompleteTree.vue?vue&type=template&id=3d91fcf0&scoped=true&"
import script from "./ProtospellingAutocompleteTree.vue?vue&type=script&lang=js&"
export * from "./ProtospellingAutocompleteTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91fcf0",
  null
  
)

export default component.exports